<div
  *ngIf="!is_read_running"
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space sp-padding">
    <h3 class="sp-color__primary">JSON</h3>

    <div
      class="sp-row__align sp-cursor__pointer"
      [mat-menu-trigger-for]="decido_menu">
      <h3 class="sp-color__primary">{{ current_type | uppercase }}</h3>
      <mat-icon class="sp-color__primary"> expand_more </mat-icon>
    </div>

    <mat-menu #decido_menu="matMenu">
      <div
        (click)="onEvaluationChange('bd1')"
        class="sp-padding__x2 sp-cursor__pointer sp-row__align sp-margin__right">
        <span class="sp-margin__left"> BD1 </span>
      </div>

      <div
        (click)="onEvaluationChange('bd2')"
        class="sp-padding__x2 sp-cursor__pointer sp-row__align sp-margin__right">
        <span class="sp-margin__left"> BD2 </span>
      </div>

      <div
        (click)="onEvaluationChange('bd5')"
        class="sp-padding__x2 sp-cursor__pointer sp-row__align sp-margin__right">
        <span class="sp-margin__left"> BD5 </span>
      </div>
    </mat-menu>
  </div>

  <div></div>

  <div
    *ngIf="!decido_evaluation"
    class="sp-padding__x12">
    <div class="sp-margin__bottom sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
    <p class="sp-text__center sp-color__primary">{{ 'ORDER_DETAILS.DECIDO_NOT_FOUND_LABEL' | translate }}</p>
    <div class="sp-margin__top sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
  </div>
  <div
    *ngIf="decido_evaluation"
    class="sp-padding__x2">
    <pre style="white-space: pre-wrap; word-break: break-all"> {{ decido_evaluation | json }} </pre>
  </div>
</div>

<div
  *ngIf="is_read_running"
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast">
  <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
</div>
